import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class PackageService {
  DoGetPackageDetail() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI.post("/api/Package/GetPackageDetail", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}

export default new PackageService();
